export enum InstallerModeLockKey {
  LOCK_X1A = 'inst_locked_x1_1',
  LOCK_X1B = 'inst_locked_x1_2',
  LOCK_X2 = 'inst_locked_x2',
}
